import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				overflow: "hidden",
				paddingBottom: 16
			},
			rootPage: {
				overflow: "scroll",
				height: "100%",
				padding: 16
			},
			rootFooter: {
				position: "absolute",
				zIndex: 5,
				bottom: 0
			},
			totalBox: {
				padding: 10,
				background: theme.palette.common.white,
				width: "100%",
				borderRadius: 6,
				boxShadow: "0px 3px 29px rgba(114, 136, 128, 0.15)"
			},
			text: {
				color: theme.palette.grey[50],
				fontSize: 12,
				textAlign: "center"
			}
		}),
	{
		name: "OrderHistoryDetailPage",
		index: 1
	}
);

export default useStyles;
